import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { MAIN_BLUE } from '../../theme';

const Section = styled.section`
  margin-top: 24px;
  font-size: 18px;
  line-height: 1.5;
`;

const Title = styled.h4`
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0 0 4px;
`;

const Name = styled.div`
  font-weight: 600;
`;

const Link = styled.a`
  color: ${MAIN_BLUE};
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${MAIN_BLUE};
    text-decoration: underline;
  }
`;

const InsurancePrefilledForm = ({ userInfo }) => {
  const {
    firstname, lastname, phone, email,
  } = userInfo;

  return (
    <Section>
      <Title>VOS COORDONNÉES</Title>
      <Name>{`${firstname} ${lastname}`}</Name>
      <Link href={`mailto:${email}`}>{email}</Link>
      <br />
      <Link href={`tel:${phone}`}>{phone}</Link>
    </Section>
  );
};

InsurancePrefilledForm.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};

export { InsurancePrefilledForm };
